// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__Yni7o","icon":"SortAdornment_icon__1oOKP","up":"SortAdornment_up__3xA5C","down":"SortAdornment_down__3sxNZ","active":"SortAdornment_active__3O9Sv"};